import { Step } from 'react-joyride'
import { useSelector } from 'react-redux'
import { IUserRoles } from 'shared/models/User'
import { getBblDisplayNames } from 'shared/store/bbl'
import { getClientIdsForUser } from 'shared/utils/rolesHelper'
import WelcomeStep from './WelcomeStep'

const useOnboardingSteps = () => {
  const { myPage } = useSelector(getBblDisplayNames)

  // Steps
  const welcomestep = {
    target: '.appwrapper',
    content: <WelcomeStep />,
    disableBeacon: true,
    placement: 'center',
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  const mainmenustep = {
    target: '.menuwrapper',
    title: 'Hovedmeny',
    content: 'Her finner du hovedmenyen',
    placement: 'right',
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  const mysiteshortcutstep = {
    target: '.mysite-shortcut',
    title: myPage,
    content: `Her finner du snarvei til ${myPage}`,
    placement: 'right',
    disableBeacon: true,
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  const relationpickerstep = {
    target: '.relation-picker',
    title: 'Bytt boligselskap',
    content: 'Her kan du bytte mellom boligselskap du er tilknyttet',
    disableBeacon: true,
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  const mobilemenustep = {
    target: '.mobilemenutoggle',
    title: 'Meny',
    content: `Her finner du hovedmenyen. I menyen finner du snarvei til ${myPage}`,
    placement: 'left',
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  const mobilemenustepwithmorecompanies = {
    target: '.mobilemenutoggle',
    title: 'Meny',
    content: `Her finner du menyen. I menyen kan du bytte mellom boligselskap du er pålogget, og finner snarvei til ${myPage}`,
    placement: 'left',
    floaterProps: {
      disableAnimation: true,
    },
  } as Step

  // Utils
  const getOnboardingMobileSteps = (roles: IUserRoles[]) => {
    const res = [welcomestep]
    res.push(
      getClientIdsForUser(roles).length > 1
        ? mobilemenustepwithmorecompanies
        : mobilemenustep
    )
    return res
  }

  return {
    mainmenustep,
    mysiteshortcutstep,
    relationpickerstep,
    welcomestep,
    getOnboardingMobileSteps,
  }
}

export default useOnboardingSteps
